import Auth from 'api/auth.api';
import Assets from 'api/assets.api';
import Notifications_Config from 'api/notifications_config.api';
import Notifications_Historic from 'api/notifications_historic.api';
import Maintenance from 'api/maintenance.api';
import Accounts from 'api/accounts.api';
import Companies from 'api/companies.api';
import Dashboard from 'api/dashboard.api';
import Users from 'api/users.api';
import Roles from 'api/roles.api';
import Groups from 'api/groups.api';
import Subcompanies from 'api/subcompanies.api';
import CustomFieldsEmployees from 'api/custom_fields_employees.api';
import Employees from 'api/employees.api';
import Uploads from 'api/uploads.api';
import Reports from 'api/reports.api';
import Subaccounts from 'api/subaccounts.api';
import Imports from 'api/imports.api';
import Depreciations from 'api/depreciations.api';
import Inpc from 'api/inpc.api';
import Exchange from 'api/exchange.api';
import CostCenters from 'api/costCenters.api';
import Catalogs from 'api/catalogs.api';
import Locations from 'api/locations.api';
import Projects from 'api/projects.api';
import AssetLevel from 'api/asset_level.api';
import Providers from 'api/providers.api';
import { ENDPOINT, DEFAULT_HEADERS } from 'api/configuration';

const Api = {
  configure(endpoint, defaultHeaders) {
    this.auth = Object.create(Auth).configure(endpoint, defaultHeaders);
    this.accounts = Object.create(Accounts).configure(endpoint, this.auth, defaultHeaders);
    this.assets = Object.create(Assets).configure(endpoint, this.auth, defaultHeaders);
    this.notifications_config = Object.create(Notifications_Config).configure(
      endpoint,
      this.auth,
      defaultHeaders
    );
    this.notifications_historic = Object.create(Notifications_Historic).configure(
      endpoint,
      this.auth,
      defaultHeaders
    );
    this.maintenance = Object.create(Maintenance).configure(endpoint, this.auth, defaultHeaders);
    this.catalogs = Object.create(Catalogs).configure(endpoint, this.auth, defaultHeaders);
    this.companies = Object.create(Companies).configure(endpoint, this.auth, defaultHeaders);
    this.costCenters = Object.create(CostCenters).configure(endpoint, this.auth, defaultHeaders);
    this.dashboard = Object.create(Dashboard).configure(endpoint, this.auth, defaultHeaders);
    // eslint-disable-next-line max-len
    this.depreciations = Object.create(Depreciations).configure(
      endpoint,
      this.auth,
      defaultHeaders
    );
    this.custom_fields_employees = Object.create(CustomFieldsEmployees).configure(
      endpoint,
      this.auth,
      defaultHeaders
    );
    this.employees = Object.create(Employees).configure(endpoint, this.auth, defaultHeaders);
    this.exchange = Object.create(Exchange).configure(endpoint, this.auth, defaultHeaders);
    this.imports = Object.create(Imports).configure(endpoint, this.auth, defaultHeaders);
    this.inpc = Object.create(Inpc).configure(endpoint, this.auth, defaultHeaders);
    this.locations = Object.create(Locations).configure(endpoint, this.auth, defaultHeaders);
    this.projects = Object.create(Projects).configure(endpoint, this.auth, defaultHeaders);
    this.asset_level = Object.create(AssetLevel).configure(endpoint, this.auth, defaultHeaders);
    this.reports = Object.create(Reports).configure(endpoint, this.auth, defaultHeaders);
    this.groups = Object.create(Groups).configure(endpoint, this.auth, defaultHeaders);
    this.roles = Object.create(Roles).configure(endpoint, this.auth, defaultHeaders);
    this.subaccounts = Object.create(Subaccounts).configure(endpoint, this.auth, defaultHeaders);
    this.subcompanies = Object.create(Subcompanies).configure(endpoint, this.auth, defaultHeaders);
    this.uploads = Object.create(Uploads).configure(endpoint, this.auth, defaultHeaders);
    this.users = Object.create(Users).configure(endpoint, this.auth, defaultHeaders);
    this.providers = Object.create(Providers).configure(endpoint, this.auth, defaultHeaders);
    return this;
  },
};

export default Object.create(Api).configure(ENDPOINT, DEFAULT_HEADERS);



// WEBPACK FOOTER //
// src/lib/api/index.js